module.exports = __webpack_public_path__ + "img/icon_dean_home_alert_icon_2.f981108a.png";